<template>
  <div id="listpage" class="flexTopCol">
    <div class="lists">
      <h1 style="margin-left: 5px">My Connections</h1>
      <div class="listNav flexLeftRow" style="margin-left: 5px">
        <BaseButton :text="'New connection'" :icon="CirclePlus" width="200px" />
      </div>
      <div class="gridView" v-if="currentView == 'activeWorkflows'">
        <div
          v-for="workflow in this.activeWorkflows"
          :key="workflow"
          class="wfItem"
        >
          <div id="statusDot"></div>
          <div class="wfTitle">{{ workflow.name }}</div>
          <div class="flexLeftRow" style="margin-top: 5px">
            <p class="listTags">{{ workflow.workflows }} workflows</p>
            <p class="listTags">{{ workflow.pages }} connected pages</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";
// import SideNav from "../../../components/utilities/SideNav.vue";
import BaseButton from "../../../components/buttons/BaseButton.vue";
import { Zap, Wrench, CirclePlus } from "lucide-vue-next";
import routerPush from "../../../utilities";

export default {
  name: "Boards",
  components: {
    BaseButton,
  },
  methods: {
    routerPush,
  },
  beforeUnmount() {},
  setup() {
    return {};
  },
  data() {
    return {
      Zap,
      Wrench,
      CirclePlus,
      currentView: "activeWorkflows",
      activeWorkflows: [
        {
          id: 1,
          name: "Google Sheets",
          workflows: "2",
          pages: "2",
          status: "active",
        },
        {
          id: 2,
          name: "Airtable",
          workflows: "3",
          pages: "2",
          status: "active",
        },
        {
          id: 3,
          name: "Typeform",
          workflows: "4",
          pages: "2",
          status: "active",
        },
        {
          id: 4,
          name: "Stripe",
          workflows: "1",
          pages: "2",
          status: "active",
        },
        {
          id: 5,
          name: "Monday.com",
          workflows: "1",
          pages: "2",
          status: "active",
        },
        {
          id: 4,
          name: "Email",
          workflows: "1",
          pages: "2",
          status: "active",
        },
        {
          id: 4,
          name: "Google Drive",
          workflows: "1",
          pages: "2",
          status: "active",
        },
        {
          id: 4,
          name: "Slack",
          workflows: "1",
          pages: "2",
          status: "active",
        },
      ],
    };
  },
};
</script>

<style scoped>
#listpage {
  position: absolute;
  left: 51px;
  right: 0;
  top: 0;
  bottom: 0;
  background: #f9f4ff;
  padding-top: 100px;
}
.lists {
  width: 1000px;
}
.listNav {
  width: 200px;
}
.gridView {
  display: grid;
  grid-template-columns: auto auto auto;
}
.wfItem {
  border: thin solid #dadada;
  border-radius: 7px;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
  /* width: 200px; */
}
.wfItem:hover {
  background: #f0e5ff;
  border: thin solid #d3c2ff;
}
.hourBreakdownChart {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  width: fit-content;
  height: 20px;
}
.hourItem {
  background: #721cff;
  width: 8px;
  margin-left: 3px;
}
.hourBase {
  width: 8px;
  background: #a8a8a8;
  height: 1px;
  margin-left: 3px;
}
.listTags {
  background: #dadada;
  border-radius: 7px;
  padding: 2px 5px;
  margin: 2px;
  font-size: 12px;
  color: #636363;
  width: fit-content;
}
.wfTitle {
  width: 200px;
  margin-top: 20px;
}
#statusDot {
  height: 9px;
  width: 9px;
  background: green;
  border-radius: 50%;
  /* margin-left: 5px; */
  /* margin-right: 5px; */
  box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
  }
  70% {
    transform: scale(1.2);
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}
</style>
